import React from 'react';
import { Table, Field, Card, View, Text, Page } from '../../components';
import { formatCurrencyOnBlur } from '../../../../helpers/utils';
import { Theme } from '../../../../theme';

const COLUMNS = [
  { Header: 'Title', accessor: 'title', width: 200 },
  { Header: 'Type', accessor: 'type', width: 50 },
  { Header: 'Assignee', accessor: 'assignee.name' },
  { Header: 'Creator', accessor: 'creator.name' },
  {
    Header: 'Urgent',
    accessor: 'urgent',
    width: 50,
    Cell: ({ cell: { value } }) => (value ? 'Yes' : 'No'),
  },
  { Header: 'Status', accessor: 'status' },
  { Header: 'Due Date', accessor: 'deadline' },
];

interface Props {
  data: any[];
  meta: any;
}

const UpcomingProjects = ({ data: projectsIn, meta }: Props) => {
  const { projects, amount, hours } = projectsIn.reduce(
    (acc, project) => ({
      projects: acc.projects + 1,
      amount: acc.amount + parseInt(project.amount_requested || 0, 10),
      hours: acc.hours + parseInt(project.estimated_hours, 10),
    }),
    { projects: 0, amount: 0, hours: 0 },
  );

  return (
    <Page meta={meta}>
      <View flexGrow={1}>
        <Card
          flexDirection="row"
          mb={24}
          borderColor="primary"
          alignItems="center"
          justifyContent="space-around"
        >
          <Field
            mb={0}
            label="Total Projects"
            value={projects}
            labelProps={{ width: 'auto' }}
          />
          <Field
            mb={0}
            label="Total Amount Requested"
            labelProps={{ width: 'auto' }}
            value={formatCurrencyOnBlur(amount.toString())}
          />
          <Field
            mb={0}
            label="Total Est Hours"
            value={hours}
            labelProps={{ width: 'auto' }}
          />
        </Card>
        {projectsIn.map(
          (
            {
              id,
              client,
              funder,
              actions,
              description,
              amount_requested: amountRequested,
              status,
              deadline,
              estimated_hours: estimatedHours,
              client_name,
              program_name,
            },
            i,
          ) => (
            <View key={id}>
              <Card justifyContent="flex-start" break={i !== 0}>
                <View flexDirection="row" width="100%">
                  <View mr={5}>
                    <Field label="Client" value={client?.name || client_name} />
                    <Field label="Funder" value={funder?.name} />
                    <Field label="Project Funded" value={program_name} />
                    <Field
                      label="Amount Requested"
                      value={formatCurrencyOnBlur(amountRequested)}
                    />
                  </View>
                  <View>
                    <Field label="Status" value={status} />
                    <Field label="Deadline" value={deadline} />
                    <Field label="Est Hours" value={estimatedHours} />
                  </View>
                </View>
                <View width="100%">
                  <Field
                    justifySelf="flex-start"
                    label="Description"
                    value={description}
                  />
                </View>
              </Card>
              <View
                py={2}
                mt={2}
                textAlign="center"
                width="100%"
                bg={Theme.colors.greyLighter}
              >
                <Text fontSize="12pt">Actions</Text>
              </View>
              <View pb="25pt">
                <Table data={actions} columns={COLUMNS} />
              </View>
            </View>
          ),
        )}
      </View>
    </Page>
  );
};

export default UpcomingProjects;
